import React from 'react';
import { Row, Col, Panel, Timeline } from 'rsuite'; // Assuming you're using rsuite
import Loader from 'react-loader-spinner'; // Assuming you're using react-loader-spinner

function CaseHistoryDiv({ isInventoryCaseHistoryLoading, InventoryCaseHistoryData }) {
    if (isInventoryCaseHistoryLoading) {
        return (
            <div align="center">
                <section className="panel">
                </section>
                <Loader
                    type="TailSpin"
                    color="#3396E5"
                    height="50"
                    width="50"
                />
            </div>
        );
    }

    if (typeof (InventoryCaseHistoryData[0]) !== 'undefined' && InventoryCaseHistoryData != null) {
        return (
            <div>
                <Row>
                    <Col md={24} sm={24}>
                        <Panel bordered header="Case History" style={{ marginBottom: 10 }}>
                            <Timeline>
                                {InventoryCaseHistoryData.map(item => (
                                    <Timeline.Item key={item.CaseHistoryID}>
                                        {item.CaseHistoryDT}  &nbsp;
                                        {item.EmailAddr}
                                        <l></l>
                                        {item.HistoryType != null ? <l><br /> {item.HistoryType} </l> : ' '}
                                        {item.StatusName != null ? <l><br /> Case Status:  {item.StatusName} </l> : ' '}
                                        {item.Container != null && item.HistoryTypeID == 1 ? <l><br /> Received From Container:  {item.Container} </l> : ' '}
                                        {item.SKU != null ? <l><br /> SKU:  {item.SKU} </l> : ' '}
                                        {/* {item.PalletBarcode != null ? <l><br /> Pallet Barcode:  {item.PalletBarcode} </l> : ' '} */}
                                        
                                        {/* {item.SerialNumber != null ? <l><br /> Serial Number:  {item.SerialNumber} </l> : ' '}
                                        {item.LotCode != null ? <l><br /> Lot Code:  {item.LotCode} </l> : ' '}
                                        {item.Notes != null ? <l><br /> Notes:  {item.Notes} </l> : ' '} */}
                                    </Timeline.Item>
                                ))}
                            </Timeline>
                        </Panel>
                    </Col>
                </Row>
            </div>
        );
    }

    return <div></div>;
}

export default CaseHistoryDiv;


